var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"Titlebar",attrs:{"data-aos":"slide-down","data-aos-delay":0}},[_vm._t("TitlebarLeft"),_vm._t("TitlebarRight")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }